import { getServiceUrlFor } from "@testavivadk/utilities";

// Helper function to get URL from different sources based on priority
const getUrl = (viteEnvironmentKey: string, serviceName: string): string => {
  if (import.meta.env.MODE === "development") {
    return import.meta.env[viteEnvironmentKey] ?? "";
  }

  return getServiceUrlFor(window.location.origin, serviceName) ?? "";
};

const applicationUrl = getUrl("VITE_APPLICATION_URL", "app");
const websiteUrl = "https://testaviva.dk";
const supportUrl = `${websiteUrl}/kategori/support`;
const logoutUrl = `${applicationUrl}/user/logout`;
const loginRedirectKey = "login_redirect";
const shopifyCartIdStorageKey = "shopify_cart_id";

// used by e2e tests
declare global {
  interface Window {
    urls?: {
      applicationUrl: string;
    };
  }
}
window.urls = { applicationUrl };

const authTokenName = "token";
const passwordlessTokenName = "passwordless_link_token";

const fileDownloadUrlParam = "download_file_url";
const authUserType = "X-Auth-Type";

export { gaEvents, analyticEvents } from "./analytics";
export { digitalProducts } from "./digitalProducts";
export { documentsCreatedIn } from "./documents";
export { campaignQueryKeys } from "./queryKeys";
export { brandSwatches, brandColorTokens } from "./brandColors";
export { brandRadius } from "./brandShape";
export {
  onboardingQuestionIds,
  maritalStatusAnswers,
  childrenAgesAnswers,
} from "./onboarding";
export {
  applicationUrl,
  websiteUrl,
  supportUrl,
  logoutUrl,
  loginRedirectKey,
  shopifyCartIdStorageKey,
  authTokenName,
  passwordlessTokenName,
  fileDownloadUrlParam,
  authUserType,
};
export { progressBarDelayMs } from "./loading";
export { genders, maritalStatuses } from "./user";
